import * as React from "react";
import { DashboardLayoutItem } from "../../types";
import { sortByReadingOrder } from "./layout/layoutUtils";
import { WidgetProps } from "./widgetRegistry";
import DashboardWidget from "./DashboardWidget";

interface IProps {
  items: DashboardLayoutItem[];
  editing: boolean;
  onMove(i: string, direction: -1 | 1): void;
  onRemove(i: string): void;
  widgetProps: WidgetProps;
}

const DashboardMobileList = ({ items, editing, onMove, onRemove, widgetProps }: IProps) => {
  const ordered = sortByReadingOrder(items);

  return (
    // Widgets take their natural content height here; their desktop height doesn't carry over to phone widths
    <div className="dashboard-mobile flex flex-col gap-6">
      {ordered.map((item, index) => (
        <div key={item.i} className="w-full">
          <DashboardWidget
            item={item}
            editing={editing}
            reorder="buttons"
            onMoveUp={index > 0 ? () => onMove(item.i, -1) : undefined}
            onMoveDown={index < ordered.length - 1 ? () => onMove(item.i, 1) : undefined}
            onRemove={() => onRemove(item.i)}
            widgetProps={widgetProps}
          />
        </div>
      ))}
    </div>
  );
};

export default DashboardMobileList;
